import { render } from "./Resizer.vue?vue&type=template&id=2437d117&lang=html"
import script from "./Resizer.vue?vue&type=script&lang=js"
export * from "./Resizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__